import { useEffect, useCallback } from 'react'
import { TaskUpdatedNotification } from 'types/pushNotifications'

type TaskUpdateListener = (taskEvent: TaskUpdatedNotification) => void

const taskUpdateListeners = new Set<TaskUpdateListener>()


export const emitTaskUpdate = (taskEvent: TaskUpdatedNotification) => {
  taskUpdateListeners.forEach(listener => listener(taskEvent))
}

export const useAutopilotTaskUpdates = (
  onTaskUpdated: (taskEvent: TaskUpdatedNotification) => void
) => {
  const handleTaskUpdate = useCallback((taskEvent: TaskUpdatedNotification) => {
    onTaskUpdated(taskEvent)
  }, [onTaskUpdated])

  useEffect(() => {
    // Subscribe to task updates
    taskUpdateListeners.add(handleTaskUpdate)
    
    return () => {
      // Cleanup: Unsubscribe when component unmounts
      taskUpdateListeners.delete(handleTaskUpdate)
    }
  }, [handleTaskUpdate])

  // TODO: Add utility functions or state here if needed
  return {
    // Add any return values here
  }
}